module.exports = __webpack_public_path__ + "img/alipay-icon.e143dd84.svg";